import { useEffect } from "react";

interface ShareModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
}

const platforms = [
  { icon: "ri-wechat-line", label: "微信", tone: "bg-accent-50 text-accent-700" },
  { icon: "ri-weibo-line", label: "微博", tone: "bg-primary-50 text-primary-600" },
  { icon: "ri-bilibili-line", label: "哔哩哔哩", tone: "bg-secondary-50 text-secondary-700" },
  { icon: "ri-link", label: "复制链接", tone: "bg-background-100 text-foreground-700" },
];

export default function ShareModal({ open, onClose, title }: ShareModalProps) {
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center px-4">
      <div className="absolute inset-0 bg-foreground-950/50 animate-fade-in" onClick={onClose} />
      <div className="relative w-full max-w-sm bg-background-50 rounded-xl p-6 animate-scale-in">
        <div className="flex items-start justify-between gap-4">
          <div>
            <h3 className="font-heading font-semibold text-lg text-foreground-950">
              分享这篇内容
            </h3>
            <p className="mt-1 text-xs text-foreground-500 line-clamp-2">{title}</p>
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="关闭"
            className="w-8 h-8 shrink-0 rounded-full flex items-center justify-center text-foreground-600 hover:bg-background-100 cursor-pointer"
          >
            <i className="ri-close-line text-xl"></i>
          </button>
        </div>

        <div className="mt-5 grid grid-cols-4 gap-3">
          {platforms.map((p) => (
            <button
              key={p.label}
              type="button"
              onClick={onClose}
              className="flex flex-col items-center gap-2 cursor-pointer group"
            >
              <span
                className={`w-12 h-12 rounded-full flex items-center justify-center ${p.tone} group-hover:scale-105 transition-transform`}
              >
                <i className={`${p.icon} text-xl`}></i>
              </span>
              <span className="text-xs text-foreground-600">{p.label}</span>
            </button>
          ))}
        </div>

        <p className="mt-5 text-xs text-foreground-400 text-center">
          分享功能为前端演示，未接入真实社交平台接口
        </p>
      </div>
    </div>
  );
}